import { type FaqProps } from './Faq'

export const defaultProps: FaqProps = {
  items: [
    {
      question: 'What is in Shakeology?',
      answer:
        'Shakeology is a nutritional supplement that typically contains a blend of proteins, vitamins, minerals, superfoods, and other ingredients. The exact ingredients may vary depending on the specific Shakeology formula, but it often includes things like whey protein, pea protein, fruits, vegetables, and various herbs and adaptogens.',
    },
    {
      question: 'Can Shakeology be used for weight loss or as a meal replacement?',
      answer:
        'Yes, Shakeology can be used as part of a weight loss plan or as a meal replacement. Many people use it as a convenient and nutritious option to replace a meal, such as breakfast or lunch. It can help control calorie intake and provide essential nutrients, which may support weight loss goals when used in conjunction with a balanced diet and exercise.',
    },
    {
      question: 'What’s the price of Shakeology?',
      answer:
        "The price of Shakeology can vary depending on the specific formula, package size, and any discounts or promotions that may be available. It's best to check the official Shakeology website or contact a Beachbody Coach for the most up-to-date pricing information.",
    },
    {
      question: 'How do you make Shakeology?',
      answer:
        "To make Shakeology, you typically mix one scoop of the Shakeology powder with water or a liquid of your choice, such as almond milk or coconut water. You can also add ice and blend it for a smoother consistency. It's important to follow the instructions on the Shakeology packaging for the specific formula you're using, as preparation methods may vary.",
    },
    {
      question: 'How do I make changes to my Shakeology subscription?',
      answer:
        'To make changes to your Shakeology subscription, you can usually do so through the official Shakeology website or by contacting Beachbody Customer Support. You can adjust the frequency of deliveries, update your shipping address, change your Shakeology formula, or cancel your subscription if needed. Be sure to review the subscription terms and policies for any specific instructions or requirements.',
    },
  ],
  hideJsonLd: false,
}
